module.exports = __webpack_public_path__ + "static/img/ezlogo.05e0b30a.png";